import CurrentHoldings from'./CurrentHoldings';export default CurrentHoldings;